import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { api } from '@/lib/api';

// Supported languages for Bangalore region
export const LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇬🇧' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी', flag: '🇮🇳' },
  { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ', flag: '🇮🇳' },
  { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்', flag: '🇮🇳' },
  { code: 'te', name: 'Telugu', nativeName: 'తెలుగు', flag: '🇮🇳' },
  { code: 'ml', name: 'Malayalam', nativeName: 'മലയാളം', flag: '🇮🇳' },
];

// UI translations for static text
export const UI_TRANSLATIONS = {
  en: {
    askQuestion: 'Ask your question anonymously...',
    askButton: 'Ask',
    voice: 'Voice',
    image: 'Image',
    video: 'Video',
    questions: 'Questions',
    answers: 'Answers',
    anonymous: 'Anonymous',
    recentQuestions: 'Recent Questions',
    noQuestions: 'No questions yet',
    beFirst: 'Be the first to ask!',
    trending: 'Trending',
    categories: 'Categories',
    browse: 'Browse',
    profile: 'Profile',
    login: 'Login',
    logout: 'Logout',
    aiAnswer: 'AI Answer',
    communityAnswers: 'Community Answers',
    writeAnswer: 'Write your answer...',
    submit: 'Submit',
    share: 'Share',
    report: 'Report',
    viewMore: 'View More',
    loading: 'Loading...',
    error: 'Something went wrong',
    selectLanguage: 'Select Language',
    students: 'Students',
    tenants: 'Tenants',
    itWork: 'IT Work',
    local: 'Local',
  },
  hi: {
    askQuestion: 'अपना सवाल गुमनाम रूप से पूछें...',
    askButton: 'पूछें',
    voice: 'आवाज़',
    image: 'फोटो',
    video: 'वीडियो',
    questions: 'सवाल',
    answers: 'जवाब',
    anonymous: 'गुमनाम',
    recentQuestions: 'हाल के सवाल',
    noQuestions: 'अभी तक कोई सवाल नहीं',
    beFirst: 'पहले सवाल पूछें!',
    trending: 'ट्रेंडिंग',
    categories: 'श्रेणियां',
    browse: 'ब्राउज़',
    profile: 'प्रोफाइल',
    login: 'लॉगिन',
    logout: 'लॉगआउट',
    aiAnswer: 'AI जवाब',
    communityAnswers: 'समुदाय के जवाब',
    writeAnswer: 'अपना जवाब लिखें...',
    submit: 'जमा करें',
    share: 'शेयर',
    report: 'रिपोर्ट',
    viewMore: 'और देखें',
    loading: 'लोड हो रहा है...',
    error: 'कुछ गलत हो गया',
    selectLanguage: 'भाषा चुनें',
    students: 'छात्र',
    tenants: 'किराएदार',
    itWork: 'IT वर्क',
    local: 'स्थानीय',
  },
  kn: {
    askQuestion: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆಯನ್ನು ಅನಾಮಧೇಯವಾಗಿ ಕೇಳಿ...',
    askButton: 'ಕೇಳಿ',
    voice: 'ಧ್ವನಿ',
    image: 'ಚಿತ್ರ',
    video: 'ವೀಡಿಯೊ',
    questions: 'ಪ್ರಶ್ನೆಗಳು',
    answers: 'ಉತ್ತರಗಳು',
    anonymous: 'ಅನಾಮಧೇಯ',
    recentQuestions: 'ಇತ್ತೀಚಿನ ಪ್ರಶ್ನೆಗಳು',
    noQuestions: 'ಇನ್ನೂ ಪ್ರಶ್ನೆಗಳಿಲ್ಲ',
    beFirst: 'ಮೊದಲು ಕೇಳಿ!',
    trending: 'ಟ್ರೆಂಡಿಂಗ್',
    categories: 'ವರ್ಗಗಳು',
    browse: 'ಬ್ರೌಸ್',
    profile: 'ಪ್ರೊಫೈಲ್',
    login: 'ಲಾಗಿನ್',
    logout: 'ಲಾಗ್ಔಟ್',
    aiAnswer: 'AI ಉತ್ತರ',
    communityAnswers: 'ಸಮುದಾಯ ಉತ್ತರಗಳು',
    writeAnswer: 'ನಿಮ್ಮ ಉತ್ತರ ಬರೆಯಿರಿ...',
    submit: 'ಸಲ್ಲಿಸಿ',
    share: 'ಹಂಚಿಕೊಳ್ಳಿ',
    report: 'ವರದಿ',
    viewMore: 'ಇನ್ನಷ್ಟು ನೋಡಿ',
    loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
    error: 'ಏನೋ ತಪ್ಪಾಗಿದೆ',
    selectLanguage: 'ಭಾಷೆ ಆಯ್ಕೆಮಾಡಿ',
    students: 'ವಿದ್ಯಾರ್ಥಿಗಳು',
    tenants: 'ಬಾಡಿಗೆದಾರರು',
    itWork: 'IT ಕೆಲಸ',
    local: 'ಸ್ಥಳೀಯ',
  },
  ta: {
    askQuestion: 'உங்கள் கேள்வியை அநாமதேயமாக கேளுங்கள்...',
    askButton: 'கேளுங்கள்',
    voice: 'குரல்',
    image: 'படம்',
    video: 'வீடியோ',
    questions: 'கேள்விகள்',
    answers: 'பதில்கள்',
    anonymous: 'அநாமதேய',
    recentQuestions: 'சமீபத்திய கேள்விகள்',
    noQuestions: 'இன்னும் கேள்விகள் இல்லை',
    beFirst: 'முதலில் கேளுங்கள்!',
    trending: 'டிரெண்டிங்',
    categories: 'வகைகள்',
    browse: 'உலாவு',
    profile: 'சுயவிவரம்',
    login: 'உள்நுழை',
    logout: 'வெளியேறு',
    aiAnswer: 'AI பதில்',
    communityAnswers: 'சமூக பதில்கள்',
    writeAnswer: 'உங்கள் பதிலை எழுதுங்கள்...',
    submit: 'சமர்ப்பி',
    share: 'பகிர்',
    report: 'புகார்',
    viewMore: 'மேலும் பார்க்க',
    loading: 'ஏற்றுகிறது...',
    error: 'ஏதோ தவறு நடந்தது',
    selectLanguage: 'மொழியை தேர்ந்தெடுங்கள்',
    students: 'மாணவர்கள்',
    tenants: 'வாடகையாளர்கள்',
    itWork: 'IT வேலை',
    local: 'உள்ளூர்',
  },
  te: {
    askQuestion: 'మీ ప్రశ్నను అనామకంగా అడగండి...',
    askButton: 'అడగండి',
    voice: 'వాయిస్',
    image: 'చిత్రం',
    video: 'వీడియో',
    questions: 'ప్రశ్నలు',
    answers: 'సమాధానాలు',
    anonymous: 'అనామక',
    recentQuestions: 'ఇటీవలి ప్రశ్నలు',
    noQuestions: 'ఇంకా ప్రశ్నలు లేవు',
    beFirst: 'మొదట అడగండి!',
    trending: 'ట్రెండింగ్',
    categories: 'వర్గాలు',
    browse: 'బ్రౌజ్',
    profile: 'ప్రొఫైల్',
    login: 'లాగిన్',
    logout: 'లాగౌట్',
    aiAnswer: 'AI సమాధానం',
    communityAnswers: 'కమ్యూనిటీ సమాధానాలు',
    writeAnswer: 'మీ సమాధానం రాయండి...',
    submit: 'సబ్మిట్',
    share: 'షేర్',
    report: 'రిపోర్ట్',
    viewMore: 'మరింత చూడండి',
    loading: 'లోడ్ అవుతోంది...',
    error: 'ఏదో తప్పు జరిగింది',
    selectLanguage: 'భాష ఎంచుకోండి',
    students: 'విద్యార్థులు',
    tenants: 'అద్దెదారులు',
    itWork: 'IT పని',
    local: 'స్థానిక',
  },
  ml: {
    askQuestion: 'നിങ്ങളുടെ ചോദ്യം അജ്ഞാതമായി ചോദിക്കുക...',
    askButton: 'ചോദിക്കുക',
    voice: 'ശബ്ദം',
    image: 'ചിത്രം',
    video: 'വീഡിയോ',
    questions: 'ചോദ്യങ്ങൾ',
    answers: 'ഉത്തരങ്ങൾ',
    anonymous: 'അജ്ഞാത',
    recentQuestions: 'സമീപകാല ചോദ്യങ്ങൾ',
    noQuestions: 'ഇതുവരെ ചോദ്യങ്ങളില്ല',
    beFirst: 'ആദ്യം ചോദിക്കുക!',
    trending: 'ട്രെൻഡിംഗ്',
    categories: 'വിഭാഗങ്ങൾ',
    browse: 'ബ്രൗസ്',
    profile: 'പ്രൊഫൈൽ',
    login: 'ലോഗിൻ',
    logout: 'ലോഗൗട്ട്',
    aiAnswer: 'AI ഉത്തരം',
    communityAnswers: 'കമ്മ്യൂണിറ്റി ഉത്തരങ്ങൾ',
    writeAnswer: 'നിങ്ങളുടെ ഉത്തരം എഴുതുക...',
    submit: 'സമർപ്പിക്കുക',
    share: 'പങ്കിടുക',
    report: 'റിപ്പോർട്ട്',
    viewMore: 'കൂടുതൽ കാണുക',
    loading: 'ലോഡ് ചെയ്യുന്നു...',
    error: 'എന്തോ കുഴപ്പം സംഭവിച്ചു',
    selectLanguage: 'ഭാഷ തിരഞ്ഞെടുക്കുക',
    students: 'വിദ്യാർത്ഥികൾ',
    tenants: 'വാടകക്കാർ',
    itWork: 'IT ജോലി',
    local: 'പ്രാദേശിക',
  },
};

const LanguageContext = createContext();

// In-memory translation cache for the session
const translationCache = new Map();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    // Get from localStorage or default to 'en'
    return localStorage.getItem('askincog_language') || 'en';
  });
  const [translating, setTranslating] = useState(false);

  useEffect(() => {
    localStorage.setItem('askincog_language', language);
  }, [language]);

  // Get translation for a key (static UI text)
  const t = (key) => {
    return UI_TRANSLATIONS[language]?.[key] || UI_TRANSLATIONS['en'][key] || key;
  };

  // Translate dynamic content on-demand
  const translateText = useCallback(async (text, targetLang = null) => {
    const target = targetLang || language;
    
    // Skip if English (original) or empty
    if (target === 'en' || !text || text.trim().length === 0) {
      return text;
    }
    
    // Check cache first
    const cacheKey = `${text.slice(0, 100)}_${target}`;
    if (translationCache.has(cacheKey)) {
      return translationCache.get(cacheKey);
    }
    
    try {
      const response = await api.post('/translate', {
        text: text,
        target_lang: target
      });
      
      const translated = response.data?.translated_text || text;
      
      // Cache the result
      translationCache.set(cacheKey, translated);
      
      return translated;
    } catch (error) {
      console.error('Translation error:', error);
      return text; // Return original on error
    }
  }, [language]);

  // Get content in selected language (for questions/answers)
  // First tries pre-stored translations, then falls back to on-demand
  const getTranslatedContent = (item, field = 'body') => {
    if (!item) return '';
    
    // Check if translations exist for this item
    const translations = item.translations;
    if (translations && translations[language] && translations[language][field]) {
      return translations[language][field];
    }
    
    // Fallback to original content
    return item[field] || '';
  };

  // Batch translate multiple texts
  const translateBatch = useCallback(async (texts, targetLang = null) => {
    const target = targetLang || language;
    
    if (target === 'en' || !texts || texts.length === 0) {
      return texts;
    }
    
    // Check what's already cached
    const results = [];
    const toTranslate = [];
    const indices = [];
    
    texts.forEach((text, idx) => {
      const cacheKey = `${text.slice(0, 100)}_${target}`;
      if (translationCache.has(cacheKey)) {
        results[idx] = translationCache.get(cacheKey);
      } else {
        toTranslate.push(text);
        indices.push(idx);
      }
    });
    
    // Translate uncached texts
    if (toTranslate.length > 0) {
      try {
        setTranslating(true);
        const response = await api.post('/translate/batch', {
          texts: toTranslate,
          target_lang: target
        });
        
        const translations = response.data?.translations || [];
        translations.forEach((item, i) => {
          const idx = indices[i];
          const translated = item.translated || texts[idx];
          results[idx] = translated;
          
          // Cache
          const cacheKey = `${texts[idx].slice(0, 100)}_${target}`;
          translationCache.set(cacheKey, translated);
        });
      } catch (error) {
        console.error('Batch translation error:', error);
        // Fill in originals for failed translations
        indices.forEach((idx, i) => {
          if (!results[idx]) results[idx] = texts[idx];
        });
      } finally {
        setTranslating(false);
      }
    }
    
    return results;
  }, [language]);

  const value = {
    language,
    setLanguage,
    t,
    translateText,
    translateBatch,
    getTranslatedContent,
    languages: LANGUAGES,
    currentLanguage: LANGUAGES.find(l => l.code === language) || LANGUAGES[0],
    translating,
    isTranslationEnabled: language !== 'en',
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
